/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Seo_SecondsInputs */

const en_seo_seconds = /** @type {(inputs: Seo_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} seconds`)
};

const zh_hans1_seo_seconds = /** @type {(inputs: Seo_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} 秒`)
};

const pt_br2_seo_seconds = /** @type {(inputs: Seo_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} segundos`)
};

const es_seo_seconds = /** @type {(inputs: Seo_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} segundos`)
};

const fr_seo_seconds = /** @type {(inputs: Seo_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} secondes`)
};

const de_seo_seconds = /** @type {(inputs: Seo_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} Sekunden`)
};

const ru_seo_seconds = /** @type {(inputs: Seo_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} с`)
};

const it_seo_seconds = /** @type {(inputs: Seo_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} secondi`)
};

/**
* | output |
* | --- |
* | "{seconds} seconds" |
*
* @param {Seo_SecondsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_seconds = /** @type {((inputs: Seo_SecondsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_SecondsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_seconds(inputs)
	if (locale === "pt-BR") return pt_br2_seo_seconds(inputs)
	if (locale === "es") return es_seo_seconds(inputs)
	if (locale === "fr") return fr_seo_seconds(inputs)
	if (locale === "de") return de_seo_seconds(inputs)
	if (locale === "ru") return ru_seo_seconds(inputs)
	if (locale === "it") return it_seo_seconds(inputs)
	return en_seo_seconds(inputs)
});